import axios from '@/utils/request'

//获取留学地址
export function getStudyAbroadUrl(position) {
  return axios.get(`/admin_api/v1/abroad/jump/${position}/config/`)
}
//保存留学后台url地址
export function saveStudyAbroadUrl(position,data) {
  return axios.put(`/admin_api/v1/abroad/jump/${position}/config/`, data)
}
